import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AgentSubscriptionRoutes = defineRoute({
    record: {
        route: {
            path: "/agent-subscription",
            component: () => loadView(import("./AgentSubscriptionTable.vue")),
        },
    },
    detail: {
        route: {
            path: "/agent-subscription/detail/:id",
            component: () => loadView(import("./AgentSubscriptionDetail.vue")),
        },
        build(id: string) {
            return `/agent-subscription/detail/${id}`;
        },
    },
});
